import { render } from "./consumptionDetails.vue?vue&type=template&id=b2633aa4&scoped=true"
import script from "./consumptionDetails.vue?vue&type=script&lang=js"
export * from "./consumptionDetails.vue?vue&type=script&lang=js"

import "./consumptionDetails.vue?vue&type=style&index=0&id=b2633aa4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b2633aa4"

export default script